import { useQuery } from "@tanstack/react-query";
import { ebooks as fallback } from "@/lib/content";

const API = process.env.REACT_APP_BACKEND_URL;
const PALETTE = [
  { cover: ["#16213A", "#0A0F1C"], ink: "#E5C158" },
  { cover: ["#2A1420", "#12080D"], ink: "#F0C9A8" },
  { cover: ["#E9E1CF", "#C9BB9C"], ink: "#1A2238" },
  { cover: ["#0F2A26", "#06120F"], ink: "#BFE3C8" },
  { cover: ["#1E1B3A", "#0D0B1C"], ink: "#D9C6F2" },
];

const loadEbooks = async () => {
  const res = await fetch(`${API}/api/ebooks`);
  if (!res.ok) throw new Error(`ebooks ${res.status}`);
  const rows = await res.json();
  if (!Array.isArray(rows) || !rows.length) throw new Error("Empty catalog");
  return rows.map((r, i) => {
    const known = fallback.find((b) => b.title === r?.title);
    const points = Array.isArray(r?.benefits) ? r.benefits : [];
    return {
      slug: r?.slug || `ebook-${i + 1}`,
      vol: String(i + 1).padStart(2, "0"),
      title: r?.title ?? "",
      price: Number(r?.price) || 0,
      tag: known?.tag ?? { id: "Ebook", en: "Ebook" },
      sub: { id: r?.description ?? "", en: r?.description ?? "" },
      points: { id: points, en: points },
      ...(known ? { cover: known.cover, ink: known.ink } : PALETTE[i % PALETTE.length]),
    };
  });
};

export const useEbooks = () => {
  const { data } = useQuery({ queryKey: ["ebooks"], queryFn: loadEbooks, enabled: !!API, retry: 1, staleTime: 60_000 });
  return Array.isArray(data) && data.length ? data : fallback;
};
